(function () {

	angular.module('qbePortal').controller('QBNoClaimBonus', QBNoClaimBonus);

	QBNoClaimBonus.$inject = ['$scope', '$state'];

	function QBNoClaimBonus($scope, $state) {
		var vm = this;

		vm.$onInit = function () {
			vm.fieldValue = vm.ngModel;
		}

		vm.stateName = $state.$current.name;

		function calcAge() {
			return (moment(new Date()).diff(moment(vm.dob, 'DD/MM/YYYY'), 'years', true));
		}

		vm.getFilteredOptions = function () {

			var fullOptions = vm.options.slice();
			var age = Math.round(calcAge());
			var product = vm.stateName.split(".");
			//removed age check and added check based on years held
			fullOptions.reverse();
			//additional check if age is below 17 or dob is undefined
			if ((age < 17) || (!vm.dob)) {
				return fullOptions.splice(0, 1);
			}

			if (product[0] != 'bike') {
				if (vm.yearsHeld == 'lessThan_1') {
					fullOptions = fullOptions.splice(0, 1);
				} else if (vm.yearsHeld == '1') {
					fullOptions = fullOptions.splice(0, 2);
				} else if (vm.yearsHeld == '2') {
					fullOptions = fullOptions.splice(0, 3);
				} else if (vm.yearsHeld == '3') {
					fullOptions = fullOptions.splice(0, 4);
				} else if (vm.yearsHeld == '4') {
					fullOptions = fullOptions.splice(0, 5);
				}
			} else {
				if (age == 17) {
					fullOptions = fullOptions.splice(0, 1);
				} else if (age == 18) {
					fullOptions = fullOptions.splice(0, 2);
				} else if (age == 19) {
					fullOptions = fullOptions.splice(0, 3);
				} else if (age == 20) {
					fullOptions = fullOptions.splice(0, 4);
				} else if (age == 21) {
					fullOptions = fullOptions.splice(0, 5);
				}
			}

			return fullOptions;

		}


		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({
				name: name,
				setHierarchyFn: setHierarchyFn
			});
		}

		vm.onValueChanged = function () {
			vm.update({
				name: vm.name,
				value: vm.fieldValue
			});
		}


	}

	angular.module('qbePortal').component('qbNoClaimBonus', {
		templateUrl: '/ngviews/components/qbNoClaimBonus.html',
		controller: QBNoClaimBonus,
		controllerAs: 'vm',
		bindings: {
			options: '<',
			name: '@',
			ngModel: '<',
			update: '&',
			setHierarchy: '&',
			dob: '<',
			yearsHeld: '<'
		}
	});
})();
